import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const AccountInfo: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <Col xs={12} className="mb-0 mb-md-0 d-flex align-items-stretch">
      <Card className="h-100 shadow-sm w-100 dashboard-card">
        <Card.Body className="d-flex flex-column justify-content-between p-4 text-start">
          <Card.Title className="fw-bold mb-3">Account Info</Card.Title>
          <div><span className="fw-semibold">Name:</span> {user?.first_name} {user?.last_name}</div>
          <div><span className="fw-semibold">Email:</span> {user?.email}</div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default AccountInfo;
